import AceEditor from 'react-ace';
import 'ace-builds/webpack-resolver';
import 'ace-builds/src-noconflict/mode-css';
import 'ace-builds/src-noconflict/theme-chrome';
import 'ace-builds/src-noconflict/worker-css';
import 'ace-builds/src-noconflict/ext-language_tools';

import { Badge, BlockStack, InlineStack } from '@shopify/polaris';
import BoldSmallText from '@/components/BoldSmallText';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { handleSaveWidgetSettings, widgetAppearanceDisableSelector, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { useDispatch } from 'react-redux';
import { StyledCSSBox } from '@/pages/WidgetAppearance/styled';
import { PlanMessage } from '@/components/PlanMessage';
import { PricingPlan } from '@/constants/enum';

export const CustomCSS = () => {
  const { t } = useTranslation('widget_settings');
  const widgetSettings = useSelector(widgetSettingSelector);
  const dispatch = useDispatch();
  const widgetAppearanceDisable = useSelector(widgetAppearanceDisableSelector);

  return (
    <BlockStack>
      <InlineStack align="space-between" gap={'200'}>
        <BoldSmallText>{t('widgetDesign.colour.css.title')}</BoldSmallText>
        {widgetAppearanceDisable.isDisableCustomStyle && <PlanMessage plan={PricingPlan.Essential} />}
      </InlineStack>
      <StyledCSSBox isDisable={widgetAppearanceDisable.isDisableCustomStyle}>
        <AceEditor
          mode="css"
          theme="chrome"
          height="150px"
          width="100%"
          value={widgetSettings.additionalCss || ''}
          placeholder={t('widgetDesign.colour.css.placeHolder')}
          onChange={(value) => dispatch(handleSaveWidgetSettings({ additionalCss: value }))}
          showPrintMargin={false}
          showGutter={false}
          highlightActiveLine={false}
          setOptions={{
            tabSize: 2,
            readOnly: widgetAppearanceDisable.isDisableCustomStyle,
            showLineNumbers: true,
          }}
          enableBasicAutocompletion={true}
          enableLiveAutocompletion={true}
        />
      </StyledCSSBox>
    </BlockStack>
  );
};
